// src/components/PageWrapper.js
import React, { useEffect } from 'react';
import { useSwipeDetection } from '../hooks/useSwipeDetection';

const PageWrapper = ({ children }) => {
  useSwipeDetection();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return children;
};

export default PageWrapper;

// ===== END OF src/components/PageWrapper.js =====